import PDFViewer from "pdf-viewer-reactjs";
import React, { useState, useEffect, useCallback } from "react";
import { Helmet } from "react-helmet";
import { useParams } from "react-router-dom";
import { backend, backend1 } from "../../../../api";
import { PageBanner } from "../../../../components";
import CustomPDFViewer from "../../../../components/CustomPDFViewer/CustomPDFViewer";
import { Grid } from "@material-ui/core";
import PlayAdModal from "./Modals/PlayAdModal";

const AdverBook = () => {
  const { downloadId } = useParams();
  const [book, setBook] = useState({});
  const [playAd, setPlayAd] = useState({});
  const [visible, setVisible] = useState(false);

  const getKleverBook = async (id) => {
    try {
      const response = await backend.get(
        `/adverbook/downloadedbooks?_id=${downloadId}`
      );
      setBook(response?.data?.data?.[0]);
    } catch (error) {
      console.error("error: ", error);
    }
  };

  const saveCurrentPage = async (currentPage, downloadId) => {
    try {
      await backend.put(`/adverbook/update-current-page/${downloadId}`, {
        currentPage,
      });
    } catch (error) {
      console.error("Failed to save current page to MongoDB:", error);
    }
  };
  const handlePageChange = (currentPage) => {
    saveCurrentPage(currentPage, downloadId);
    const adSlots = book?.ad_slots;
    const ads = book?.ads;

    const slotIndex = adSlots.findIndex(
      (slot) => parseInt(slot) === currentPage
    );

    if (slotIndex !== -1 && ads[slotIndex]) {
      const ad = ads[slotIndex];
      setPlayAd(ad);
      setVisible(true);
    }
  };

  useEffect(() => {
    getKleverBook(downloadId);
  }, [downloadId]);

  return (
    <div>
      <Helmet>
        <title>KleverBook Reading Zone</title>
      </Helmet>
      <PageBanner
        title="KleverBook Reading Zone"
        image="/assets/images/bg4.jpg"
      />
      <Grid container justifyContent="center" alignItems="center">
        <Grid item xs="12" lg="8">
          {book?.book?.pdf_file && (
            <CustomPDFViewer
              url={book?.book?.pdf_file}
              bookId={book?._id}
              onPageChange={handlePageChange}
            />
          )}
        </Grid>
      </Grid>
      {visible && (
        <PlayAdModal
          downloadBook={book}
          ad={playAd}
          setVisible={setVisible}
          visible={visible}
          setPlayAd={setPlayAd}
        />
      )}
    </div>
  );
};

export default AdverBook;
